import { Link } from 'react-router'
import linksConfig from '@/site/lib/linksConfig'
import NewsletterSignup from './NewsletterSignup'

export default function Footer() {
  const year = new Date().getFullYear()

  return (
    <footer className="mt-20 bg-qt-primary text-white">
      <div className="qt-container pt-12">
        <NewsletterSignup />
      </div>
      <div className="qt-container grid gap-10 py-12 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div className="flex flex-col gap-3">
          <p className="text-xl font-extrabold">Quilting Tutorials</p>
          <p className="text-sm font-medium">Free quilting video tutorials from Missouri Star Quilt Co.</p>
        </div>
        <nav aria-label="Browse" className="flex flex-col gap-2.5 text-sm font-semibold">
          <p className="font-extrabold">Browse</p>
          <Link to="/tutorials" className="hover:underline">All tutorials</Link>
          <Link to="/Skill-Level/Beginner" className="hover:underline">Beginner tutorials</Link>
          <Link to="/tutorials?sort=popular" className="hover:underline">Most watched</Link>
        </nav>
        <nav aria-label="Missouri Star" className="flex flex-col gap-2.5 text-sm font-semibold">
          <p className="font-extrabold">Missouri Star</p>
          {linksConfig.sisterSites.map((s) => (
            <a key={s.title} href={s.location} target="_blank" rel="noreferrer" className="hover:underline">
              {s.title}
            </a>
          ))}
        </nav>
        <nav aria-label="Follow us" className="flex flex-col gap-2.5 text-sm font-semibold">
          <p className="font-extrabold">Follow</p>
          {linksConfig.social
            .filter((s) => s.location)
            .map((s) => (
              <a key={s.title} href={s.location} target="_blank" rel="noreferrer" className="hover:underline">
                {s.title}
              </a>
            ))}
          <a href="https://www.youtube.com/user/MissouriQuiltCo" target="_blank" rel="noreferrer" className="hover:underline">
            YouTube
          </a>
        </nav>
      </div>
      <div className="border-t border-white/20">
        <p className="qt-container py-5 text-xs font-medium">&copy; 2011–{year} Missouri Star Quilt Co.</p>
      </div>
    </footer>
  )
}
